// extracted by mini-css-extract-plugin
export default {"root":"legalFooter_root__jw-wF"};